import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Text } from "../../../externalComponents/tailwind/text";
import { SendingListFuture } from "../../../externalComponents/analytics/SendingListFuture";

export default function ScheduledSendings({ user, isMobile }) {
  const navigate = useNavigate();
  const [scheduledCursor, setScheduledCursor] = useState({ first: 5 });
  const [scheduledPageNumber, setScheduledPageNumber] = useState(1);

  return (
    <>
      <br />
      <Text className="text-xl font-bold">Scheduled messages</Text>
      <br />
      <SendingListFuture
        customerId={user.customerId}
        showCancelButton={true}
        showPagination={true}
        itemsPerPage={5}
        isMobile={isMobile}
        onRowClick={(campaignId) => navigate(`/campaigns/edit/${campaignId}`)}
        cursor={scheduledCursor}
        setCursor={setScheduledCursor}
        pageNumber={scheduledPageNumber}
        setPageNumber={setScheduledPageNumber}
      />
    </>
  );
}
